import { ACCESS_LEVEL, ACCESS_LEVEL_RANK, ACTION } from "./constants";
import { getCurrentAccess } from "./getCurrentAccess";

const getModuleName = (moduleKey) => {
  if (moduleKey == null) return "";
  if (typeof moduleKey === "object") {
    return moduleKey.name || String(moduleKey.id ?? "");
  }
  return String(moduleKey);
};

const matchesModule = (module, moduleKey) => {
  const key = getModuleName(moduleKey);
  return (
    module.name === key ||
    String(module.id) === key ||
    module.id === moduleKey
  );
};

export const getAccessLevel = (moduleKey, access = getCurrentAccess()) => {
  const key = getModuleName(moduleKey);
  if (!key) return null;

  const permissions = access?.permissions || {};
  return permissions[key] || permissions[String(key)] || null;
};

export const canAccess = (moduleKey, access = getCurrentAccess()) => {
  const modules = Array.isArray(access?.modules) ? access.modules : [];
  if (modules.some((module) => matchesModule(module, moduleKey))) return true;
  return Boolean(getAccessLevel(moduleKey, access));
};

export const hasAnyAccess = (access = getCurrentAccess()) => {
  if (Array.isArray(access?.modules) && access.modules.length > 0) return true;
  return Object.keys(access?.permissions || {}).length > 0;
};

export const canRead = (moduleKey, access = getCurrentAccess()) => {
  const level = getAccessLevel(moduleKey, access);
  return ACCESS_LEVEL_RANK[level] >= ACCESS_LEVEL_RANK[ACCESS_LEVEL.read];
};

export const canWrite = (moduleKey, access = getCurrentAccess()) => {
  const level = getAccessLevel(moduleKey, access);
  return ACCESS_LEVEL_RANK[level] >= ACCESS_LEVEL_RANK[ACCESS_LEVEL.readWrite];
};

export const canPerformAction = (
  moduleKey,
  action = ACTION.read,
  access = getCurrentAccess()
) => {
  switch (action) {
    case ACTION.write:
      return canWrite(moduleKey, access);
    case ACTION.access:
      return canAccess(moduleKey, access);
    case ACTION.read:
    default:
      return canRead(moduleKey, access);
  }
};
